import React, {ReactElement} from 'react'
import {FlexContainer, FlexStaticContent} from '../styledComponents/FlexComponents'
import NatAdminHeaderAreaComponent from '../components/header/AdminHeaderAreaComponent'
import {ContentsAreaComponent} from '../styledComponents/ContentsArea'
import {RoutesAdmin} from './RoutesAdmin'
import FooterAreaComponentAdmin from './FooterAreaComponentAdmin'
import {StyledDiv} from '../styledComponents/StyledTypeDefinitions'
import styled, {ThemeProvider as StyledThemeProvider} from 'styled-components'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import AdminAuthRepository from '../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import {EquipmentsRepository} from '../components/equipments/EquipmentsRepository'
import {GlobalStyleAdmin} from '../styledComponents/GlobalStyleAdmin'
import {ErrorBoundary} from '../components/shared/pageBaseComponents/ErrorBoundary'
import {CssBaseline, ThemeProvider as MaterialThemeProvider} from '@mui/material'
import {AdminPageTheme} from '../styledComponents/adminPage/AdminPageTheme'
import EventEmitterExAdmin from '../components/shared/pageBaseComponents/EventEmitterExAdmin'
import FacilityModel from '../components/facilities/FacilityModel'
import {SubRoutesAdmin} from '../__NoAutomatedTests/SubRoutesAdmin'
import ReservationsRepository from '../components/reservations/ReservationsRepository'
import NatCondominiumRepo from '../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatAdminUserRepo from '../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import NatRoomToResidentRepo from '../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumGroupRepo
    from '../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatScheduleRepo from '../__NoAutomatedTests/components/schedule/repository/NatScheduleRepo'
import NatEventRepo from '../__NoAutomatedTests/components/event/repository/NatEventRepo'
import NatRidgeRepo from '../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import NatTokenRepo from '../__NoAutomatedTests/components/token/repository/NatTokenRepo'
import NatPasswordRepo from '../__NoAutomatedTests/components/password/repository/NatPasswordRepo'
import NatMessageRepo from '../__NoAutomatedTests/components/message/repository/NatMessageRepo'
import NatLifeNoteRepo from '../__NoAutomatedTests/components/lifeNote/repository/NatLifeNoteRepo'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatHolidayMasterRepo from '../__NoAutomatedTests/components/holiday/repository/NatHolidayMasterRepo'
import NatSessionRepo from '../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import NatLoginBeforeMessageRepo
    from '../__NoAutomatedTests/components/loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import NatClosedSettingRepo from '../__NoAutomatedTests/components/closedSetting/repository/NatClosedSettingRepo'
import NatMenuMasterRepo from '../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import NatUseFunctionMasterRepo
    from '../__NoAutomatedTests/components/useFunctionMaster/repository/NatUseFunctionMasterRepo'
import NatCondominiumAuthoritySettingRepo
    from '../__NoAutomatedTests/components/condominiumAuthoritySetting/repository/NatCondominiumAuthoritySettingRepo'
import {SessionStorageHelper} from '../SessionStorageHelper'
import NatOwnerCondominiumRepo
    from '../__NoAutomatedTests/components/ownerCondominium/repository/NatOwnerCondominiumRepo'
import NatApartAssocInfoRepo from '../__NoAutomatedTests/components/apartAssocInfo/repository/NatApartAssocInfoRepo'
import NatFacilityRepo from '../__NoAutomatedTests/components/facility/repository/NatFacilityRepo'
import equal from 'fast-deep-equal'
import {Colors, DisplaySizeValue} from '../styledComponents/Constants'
import {ReservationsRepositoryForAdmin} from '../components/reservations/admin/ReservationsRepositoryForAdmin'
import NatRoomNumberRepo from '../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import AdminUserRepository from '../components/adminUser/AdminUserRepository'
import NatFacilityReserveRepo from '../__NoAutomatedTests/components/facilityReserve/repository/NatFacilityReserveRepo'
import ReserveFacilityPaymentModel from '../components/reservations/ReserveFacilityPaymentModel'
import {ReserveFacilityModel} from '../components/reservations/ReserveFacilityModel'
import ReservePaymentCalculatorFactory
    from '../components/reservations/paymentCalculators/ReservePaymentCalculatorFactory'
import HolidaysRepository from '../components/HolidaysRepository'
import NatBulletinBoardRepo from '../__NoAutomatedTests/components/bulletinBoard/repository/NatBulletinBoardRepo'
import {PersonalInfoExtractHistoryRepo} from '../components/PersonalInfoExtractHistoryRepo'
import NatMaintenanceSettingMasterRepo
    from '../__NoAutomatedTests/components/maintenance/repository/NatMaintenanceSettingMasterRepo'
import NatExtractHistoryRepo from '../__NoAutomatedTests/components/extract/repository/NatExtractHistoryRepo'
import NatAreaCodeRepo from '../__NoAutomatedTests/components/areaCode/repository/NatAreaCodeRepo'
import {MeetingRepositoryForAdmin} from '../components/assocDirector/MeetingRepositoryForAdmin'
import {
    AdminNotificationReceiveSettingRepo,
} from '../components/notificationReceiveSetting/AdminNotificationReceiveSettingRepo'
import AssocDirectorRepository from '../components/assocDirector/AssocDirectorRepository'
import {NatApplicationRepo} from '../__NoAutomatedTests/components/applications/repository/NatApplicationRepo'
import AssocManagementRepository from '../components/assocDirector/AssocManagementRepository'
import {isMobile} from 'react-device-detect'
import {AppAdminContext} from './AppAdminContext'
import {
    NatAssocWorkReportRepo,
} from '../__NoAutomatedTests/components/assocWorkReports/repository/NatAssocWorkReportRepo'
import {NatFileRepo} from '../__NoAutomatedTests/components/files/repository/NatFileRepo'
import {
    NatOwnershipTransfersRepo,
} from '../__NoAutomatedTests/components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import {AdminSessionUtil} from './AdminSessionUtil'
import NatResidentUserRepo from '../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo';
import {Route, Routes} from 'react-router-dom'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'
import NatDisasterRepo from '../__NoAutomatedTests/components/disaster/repository/NatDisasterRepo'
import AdminGeneralMeetingRepo from '../components/generalMeeting/AdminGeneralMeetingRepo'

const EVENT_EMITTER_SET_MAX_LISTENERS: number = 1000

interface Props {
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    adminAuthRepo: AdminAuthRepository
    equipmentsRepo: EquipmentsRepository
    meetingRepoForAdmin: MeetingRepositoryForAdmin
    adminNotificationReceiveSettingRepo: AdminNotificationReceiveSettingRepo
    natTokenRepo: NatTokenRepo
    natCondominiumRepo: NatCondominiumRepo
    natAdminUserRepo: NatAdminUserRepo
    natRoomToResidentRepo: NatRoomToResidentRepo
    natCondominiumGroupRepo: NatCondominiumGroupRepo
    natScheduleRepo: NatScheduleRepo
    natEventRepo: NatEventRepo
    natRidgeRepo: NatRidgeRepo
    natPasswordRepo: NatPasswordRepo
    natMessageRepo: NatMessageRepo
    natCurrentDateTimeRepo: NatCurrentDateTimeRepo
    natHolidayMasterRepo: NatHolidayMasterRepo
    natLifeNoteRepo: NatLifeNoteRepo
    natSessionRepo: NatSessionRepo
    natLoginBeforeMessageRepo: NatLoginBeforeMessageRepo
    natClosedSettingRepo: NatClosedSettingRepo
    natMenuMasterRepo: NatMenuMasterRepo
    natUseFunctionMasterRepo: NatUseFunctionMasterRepo
    natCondominiumAuthoritySettingRepo: NatCondominiumAuthoritySettingRepo
    natOwnerCondominiumRepo: NatOwnerCondominiumRepo
    natApartAssocInfoRepo: NatApartAssocInfoRepo
    natFacilityRepo: NatFacilityRepo
    natRoomNumberRepo: NatRoomNumberRepo
    adminUserRepo: AdminUserRepository
    natFacilityReserveRepo: NatFacilityReserveRepo
    holidaysRepo: HolidaysRepository
    natBulletinBoardRepo: NatBulletinBoardRepo
    personalInfoExtractHistoryRepo: PersonalInfoExtractHistoryRepo
    natAreaCodeRepo: NatAreaCodeRepo
    natMaintenanceSettingMasterRepo: NatMaintenanceSettingMasterRepo
    natExtractHistoryRepo: NatExtractHistoryRepo
    assocManagementRepo: AssocManagementRepository
    assocDirectorRepo: AssocDirectorRepository
    applicationRepo: NatApplicationRepo
    fileRepo: NatFileRepo
    assocWorkReportRepo: NatAssocWorkReportRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    residentUserRepo: NatResidentUserRepo
    disasterRepo: NatDisasterRepo
    adminGeneralMeetingRepo: AdminGeneralMeetingRepo
}

interface State {
    loginedFlg: boolean,
    showSpModePage: boolean,
}

export default class AppAdmin extends React.Component<Props, State> {
    private eventEmitter: EventEmitterExAdmin
    private facilityModel: FacilityModel
    private reservationModel: ReserveFacilityModel
    private paymentModel: ReserveFacilityPaymentModel
    private paymentCalculatorFactory: ReservePaymentCalculatorFactory
    private adminSessionUtil: AdminSessionUtil

    constructor(props: Props) {
        super(props)
        this.state = {
            loginedFlg: (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null),
            showSpModePage: false,
        }
        this.eventEmitter = new EventEmitterExAdmin()
        this.eventEmitter.setMaxListeners(EVENT_EMITTER_SET_MAX_LISTENERS)
        this.facilityModel = new FacilityModel()
        this.paymentCalculatorFactory = new ReservePaymentCalculatorFactory()
        this.paymentModel = new ReserveFacilityPaymentModel(this.paymentCalculatorFactory)
        this.reservationModel = new ReserveFacilityModel(this.paymentModel)
        this.adminSessionUtil = new AdminSessionUtil(
            props.adminAuthRepo,
            props.natSessionRepo,
            props.natMenuMasterRepo,
        )
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        if (!equal(prevState.loginedFlg, (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null))) {
            this.setState(
                {loginedFlg: (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null)})
        }
    }

    updateShowSpModePage = (showSpModePage: boolean): void => {
        if (this.state.showSpModePage !== showSpModePage) {
            this.setState({showSpModePage: showSpModePage})
        }
    }

    renderNoLoginAdminHeader(): ReactElement {
        return <>
            <RouterPropsInjector>{(props) =>
                <NatAdminHeaderAreaComponent
                    loginedFlg={false}
                    condominiumRepo={this.props.natCondominiumRepo}
                    condominiumGroupRepo={this.props.natCondominiumGroupRepo}
                    adminUserRepo={this.props.natAdminUserRepo}
                    menuMasterRepo={this.props.natMenuMasterRepo}
                    sessionRepo={this.props.natSessionRepo}
                    currentDateTimeRepo={this.props.natCurrentDateTimeRepo}
                    eventEmitter={this.eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    residentUserRepo={this.props.residentUserRepo}
                    adminSessionUtil={this.adminSessionUtil}
                />
            }</RouterPropsInjector>
        </>
    }

    render(): ReactElement {
        return (
            <AppAdminContext.Provider
                value={{
                    showSpModePage: this.state.showSpModePage,
                    updateShowSpModePage: this.updateShowSpModePage,
                }}
            >
                <MaterialThemeProvider theme={AdminPageTheme}>
                    <StyledThemeProvider theme={AdminPageTheme}>
                        <CssBaseline/>
                        <GlobalStyleAdmin $spMode={this.state.showSpModePage}/>
                        <RootFlexContainer>
                            <AdminHeaderFlexContainer>
                                <Routes>
                                    withAsyncCommunication()
                                    <Route
                                        path="/admin/login"
                                        element={this.renderNoLoginAdminHeader()}
                                    />
                                    <Route
                                        path="/admin/assoc/login"
                                        element={this.renderNoLoginAdminHeader()}
                                    />
                                    <Route
                                        path="/admin/login-portal"
                                        element={this.renderNoLoginAdminHeader()}
                                    />
                                    <Route
                                        path="/admin/changePassword"
                                        element={this.renderNoLoginAdminHeader()}
                                    />
                                    <Route
                                        path="/admin/error"
                                        element={this.renderNoLoginAdminHeader()}
                                    />
                                    <Route
                                        path="/*"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatAdminHeaderAreaComponent
                                                loginedFlg={this.state.loginedFlg}
                                                condominiumRepo={this.props.natCondominiumRepo}
                                                condominiumGroupRepo={this.props.natCondominiumGroupRepo}
                                                adminUserRepo={this.props.natAdminUserRepo}
                                                menuMasterRepo={this.props.natMenuMasterRepo}
                                                sessionRepo={this.props.natSessionRepo}
                                                currentDateTimeRepo={this.props.natCurrentDateTimeRepo}
                                                eventEmitter={this.eventEmitter}
                                                adminSessionUtil={this.adminSessionUtil}
                                                residentUserRepo={this.props.residentUserRepo}
                                                {...props}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                </Routes>
                            </AdminHeaderFlexContainer>

                            <AdminContentsAreaContainer>
                                <ContentsAreaComponent>
                                    <ErrorBoundary>
                                        <Routes>
                                            {RoutesAdmin({
                                                facilitiesRepo: this.props.facilitiesRepo,
                                                equipmentsRepo: this.props.equipmentsRepo,
                                                reservationsRepoForAdmin: this.props.reservationsRepoForAdmin,
                                                ridgeRepo: this.props.natRidgeRepo,
                                                roomNumberRepo: this.props.natRoomNumberRepo,
                                                roomToResidentRepo: this.props.natRoomToResidentRepo,
                                                adminUserRepo: this.props.adminUserRepo,
                                                eventEmitter: this.eventEmitter,
                                                facilityModel: this.facilityModel,
                                                currentDateTimeRepo: this.props.natCurrentDateTimeRepo,
                                                holidaysRepo: this.props.holidaysRepo,
                                                meetingRepoForAdmin: this.props.meetingRepoForAdmin,
                                                adminNotificationReceiveSettingRepo:
                                                this.props.adminNotificationReceiveSettingRepo,
                                                natAdminUserRepo: this.props.natAdminUserRepo,
                                                natCondominiumGroupRepo: this.props.natCondominiumGroupRepo,
                                                assocManagementRepo: this.props.assocManagementRepo,
                                                assocDirectorRepo: this.props.assocDirectorRepo,
                                                natCondominiumRepo: this.props.natCondominiumRepo,
                                                adminGeneralMeetingRepo: this.props.adminGeneralMeetingRepo,
                                                natFileRepo: this.props.fileRepo,
                                            })}
                                            {SubRoutesAdmin({
                                                adminAuthRepo: this.props.adminAuthRepo,
                                                condominiumRepo: this.props.natCondominiumRepo,
                                                adminUserRepo: this.props.natAdminUserRepo,
                                                roomToResidentRepo: this.props.natRoomToResidentRepo,
                                                condominiumGroupRepo: this.props.natCondominiumGroupRepo,
                                                scheduleRepo: this.props.natScheduleRepo,
                                                eventRepo: this.props.natEventRepo,
                                                ridgeRepo: this.props.natRidgeRepo,
                                                messageRepo: this.props.natMessageRepo,
                                                currentDateTimeRepo: this.props.natCurrentDateTimeRepo,
                                                holidayMasterRepo: this.props.natHolidayMasterRepo,
                                                lifeNoteRepo: this.props.natLifeNoteRepo,
                                                eventEmitter: this.eventEmitter,
                                                sessionRepo: this.props.natSessionRepo,
                                                loginBeforeMessageRepo: this.props.natLoginBeforeMessageRepo,
                                                closedSettingRepo: this.props.natClosedSettingRepo,
                                                menuMasterRepo: this.props.natMenuMasterRepo,
                                                useFunctionMasterRepo: this.props.natUseFunctionMasterRepo,
                                                condominiumAuthoritySettingRepo:
                                                this.props.natCondominiumAuthoritySettingRepo,
                                                ownerCondominiumRepo: this.props.natOwnerCondominiumRepo,
                                                apartAssocInfoRepo: this.props.natApartAssocInfoRepo,
                                                facilityRepo: this.props.natFacilityRepo,
                                                facilityReserveRepo: this.props.natFacilityReserveRepo,
                                                facilitiesRepo: this.props.facilitiesRepo,
                                                reservationModel: this.reservationModel,
                                                holidaysRepo: this.props.holidaysRepo,
                                                reservationsRepoForAdmin: this.props.reservationsRepoForAdmin,
                                                bulletinBoardRepo: this.props.natBulletinBoardRepo,
                                                personalInfoExtractHistoryRepo:
                                                this.props.personalInfoExtractHistoryRepo,
                                                areaCodeRepo: this.props.natAreaCodeRepo,
                                                maintenanceSettingMasterRepo:
                                                this.props.natMaintenanceSettingMasterRepo,
                                                extractHistoryRepo: this.props.natExtractHistoryRepo,
                                                applicationRepo: this.props.applicationRepo,
                                                fileRepo: this.props.fileRepo,
                                                assocWorkReportRepo: this.props.assocWorkReportRepo,
                                                ownershipTransfersRepo: this.props.ownershipTransfersRepo,
                                                roomNumberRepo: this.props.natRoomNumberRepo,
                                                assocManagementRepo: this.props.assocManagementRepo,
                                                adminSessionUtil: this.adminSessionUtil,
                                                residentUserRepo: this.props.residentUserRepo,
                                                disasterRepo: this.props.disasterRepo,
                                            })}
                                        </Routes>
                                    </ErrorBoundary>
                                </ContentsAreaComponent>
                            </AdminContentsAreaContainer>

                            <FlexStaticContent>
                                <FooterAreaComponentAdmin/>
                            </FlexStaticContent>
                        </RootFlexContainer>
                    </StyledThemeProvider>
                </MaterialThemeProvider>
            </AppAdminContext.Provider>
        )
    }
}

// @ts-ignore
const RootFlexContainer: StyledDiv = styled(FlexContainer)`
  flex-direction: column;
  height: 100vh;
  background: ${Colors.Background};
`

const AdminHeaderFlexContainer = styled.div`
  flex: 0 0 auto;
  min-width: ${isMobile ? DisplaySizeValue.ResidentWidthMin : DisplaySizeValue.AdminWidthMin}px;
`

const AdminContentsAreaContainer: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  background-color: ${Colors.Background};
  font-size: 0.875rem;
`
